var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentStreamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1010105640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    d: "M25.6066 26.1066C28.0605 23.6527 29.5876 20.4239 29.9278 16.9703C30.2679 13.5166 29.4001 10.0519 27.472 7.16645C25.544 4.28097 22.6752 2.15328 19.3543 1.1459C16.0334 0.138512 12.4659 0.31377 9.25975 1.64181C6.05358 2.96984 3.40708 5.36849 1.77118 8.42905C0.135279 11.4896 -0.388807 15.0227 0.288221 18.4264C0.965248 21.83 2.8015 24.8936 5.4841 27.0952C8.1667 29.2967 11.5297 30.5 15 30.5V26.9834C12.3432 26.9834 9.76868 26.0623 7.71498 24.3768C5.66128 22.6914 4.25551 20.346 3.73721 17.7403C3.2189 15.1346 3.62012 12.4298 4.8725 10.0867C6.12489 7.74369 8.15095 5.90738 10.6055 4.89068C13.06 3.87398 15.7911 3.73981 18.3335 4.51103C20.8758 5.28224 23.0721 6.91113 24.5481 9.12014C26.0242 11.3292 26.6886 13.9816 26.4282 16.6256C26.1677 19.2695 24.9986 21.7414 23.12 23.62L25.6066 26.1066Z",
    fill: "#FEBC2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3466533",
    d: "M14.875 26.9844H26.4604L29.753 30.5004H14.875V26.9844Z",
    fill: "#FEBC2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634049"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 179",
    x1: 7.78906,
    y1: 12.5838,
    x2: 22.0098,
    y2: 12.5838,
    stroke: "#79310E",
    strokeWidth: 1.31674
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 180",
    x1: 7.78906,
    y1: 14.951,
    x2: 22.0098,
    y2: 14.951,
    stroke: "#79310E",
    strokeWidth: 1.31674
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 182",
    x1: 8.45101,
    y1: 15.3437,
    x2: 8.45101,
    y2: 12.1836,
    stroke: "#79310E",
    strokeWidth: 1.31674
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 181",
    x1: 7.78906,
    y1: 18.1151,
    x2: 22.0098,
    y2: 18.1151,
    stroke: "#79310E",
    strokeWidth: 1.31674
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentStreamLogo);
export default __webpack_public_path__ + "static/media/commentStreamLogo.f87d793db2d0d8eed769d2081e37c53f.svg";
export { ForwardRef as ReactComponent };